module.exports = __webpack_public_path__ + "img/icon_ie.2acce9e0.svg";